<div>
  <div mat-card-title>Raw material inventory status</div>
  <div class="mt-2 p-1">
    <nz-table #nzTable [nzData]="rawMaterialStatus" nzTableLayout="fixed" nzBordered nzShowPagination nzShowSizeChanger
      nzOuterBordered>
      <thead>
        <tr>
          <th class="text-center">Name</th>
          <th class="text-center">Measuring Unit</th>
          <th class="text-center">Availability</th>
          <th class="text-center">Demand</th>
          <th class="text-center">Need to buy</th>
        </tr>
      </thead>
      <tbody>
        @for (data of nzTable.data; track data) {
          <tr>
            <td class="text-center">{{data.Item}}</td>
            <td class="text-center">{{data.Count}}</td>
            <td class="text-center">{{data.Revenue}}</td>
            <td class="text-center">{{data.Count}}</td>
            <td class="text-center">{{data.Revenue}}</td>
          </tr>
        }
      </tbody>
    </nz-table>
  </div>
</div>
